import { datadogRum } from '@datadog/browser-rum'

const trackElementStateForDatadog = ({
  query,
  timeout = 3000,
  eventName,
  flow,
}: {
  query: string
  timeout?: number
  eventName: string
  flow?: string
}) => {
  setTimeout(() => {
    const el = document.querySelector(query)
    if (
      !el ||
      (el as HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement)
        .disabled
    ) {
      datadogRum.addError(eventName, {
        flow,
        severity: 'critical',
      })
    }
  }, timeout)
}

export default trackElementStateForDatadog
